module.exports = __webpack_public_path__ + "static/media/schedule-desktop.48aedb71.svg";